export default {
  index: [
    {
      path: '/cwcommodity',
      component: resolve => require(['./cwcommodityIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/cwcommodity/_router.js